module.exports = __webpack_public_path__ + "img/cooperativeMedia17.7782a66d.png";